import React from 'react';
import classNames from 'classnames/bind';
import CDNImage from '../../utils/CDNImage';
import HoverCard from '../../components/Hover/HoverCard';

import styles from './Trademarks.module.scss';

let cx = classNames.bind(styles);

const Trademarks = () => {
	return (
		<section id='marcas' className={cx({ trademarks: true, 'mt-20': true })}>
			<div className='w-full flex flex-row'>
				<div className='flex flex-row w-2/3 lg:w-1/2'>
					<div className='flex w-1/4 bg-tcn-dark-blue h-6'></div>
					<div className='flex w-1/4 bg-tcn-red h-6'></div>
					<div className='flex w-1/4 bg-tcn-light-blue h-6'></div>
					<div className='flex w-1/4 bg-tcn-cyan h-6'></div>
				</div>
				<div className='flex flex-col w-1/2 justify-start items-end'>
					<CDNImage
						className='hidden lg:flex'
						image_name={'20200521_IDEAL_tcn-33.png'}
						alt='IDEAL_tcn'
					/>
				</div>
			</div>
			<div className='flex flex-col p-4 lg:p-0'>
				<h1 className='container mx-auto text-tcn-dark-blue font-Avenir-Black text-4xl py-4 text-center lg:text-left'>
					<span className='font-Avenir-Black font-bold text-3xl lg:text-5xl'>NUESTRAS MARCAS</span>
				</h1>
				<div className='hidden lg:flex flex-col lg:flex-row h-32 w-full'>
					<div className='flex flex-col justify-end items-start w-1/3'>
						<div className={cx({ cirle_cyan: true })}></div>
					</div>
					<div className='flex flex-col justify-start items-center w-1/3'>
						<div className={cx({ cirle_light_blue: true })}></div>
					</div>
					<div className='flex flex-col justify-end items-end w-1/3 pr-20'>
						<div className={cx({ cirle_red: true })}></div>
					</div>
				</div>
			</div>
			<div className='container mx-auto flex flex-col'>
				<CDNImage
					className='hidden lg:flex'
					image_name={'marcas.png'}
					alt='MArcas'
				/>
				<CDNImage
					className='flex lg:hidden'
					image_name={'mobile/trademarks_mobile.png'}
					alt='MArcas'
				/>

			</div>
		</section>
	);
};

export default Trademarks;
